import React from 'react';
import { Form, RadioGroup, RadioItem } from 'src/components/Antd';
import css from './css.module.less';
import { get } from 'lodash';
import { OriNumberInput } from 'src/components/Antd/NumberInput/NumberInput';
//import { InputNumber as OriNumberInput } from 'antd';

import numberCss from './number.module.less';
import { instanceType, AllTypes } from 'src/tools/helper';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

const Item = Form.Item;
export enum EType {
  LARGER_THAN = 'LARGER_THAN',
  SMALLER_THAN = 'SMALLER_THAN',
  EQUALS = 'EQUALS',
  IN_BETWEEN = 'IN_BETWEEN',
}
export const defaultState = {
  type: null,
};

const CommonAmount = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    noStyle,
    nameType,
    nameValue,
    nameRange,
    rules,
    suffix,
    isTypeRequired,
    precision,
    disabled,
  } = props;

  return (
    <React.Fragment>
      <Item
        name={nameType}
        noStyle={noStyle}
        rules={[
          {
            required: isTypeRequired,
            message: getI18n('general.advancedFilters.commonAmount.message'),
          },
        ]}>
        <RadioGroup className={css.groupContainer} disabled={disabled}>
          <RadioItem className={css.item} value={EType.LARGER_THAN}>
            {getI18n('general.advancedFilters.commonAmount.largerThan')}
          </RadioItem>
          <RadioItem className={css.item} value={EType.SMALLER_THAN}>
            {getI18n('general.advancedFilters.commonAmount.smallerThan')}
          </RadioItem>
          <RadioItem className={css.item} value={EType.EQUALS}>
            {getI18n('general.advancedFilters.commonAmount.equalTo')}
          </RadioItem>
          <RadioItem className={css.item} value={EType.IN_BETWEEN}>
            {getI18n('general.advancedFilters.commonAmount.inBetween')}
          </RadioItem>
        </RadioGroup>
      </Item>
      <Item
        noStyle
        shouldUpdate={(p, c) => {
          const cT = get(c, nameType);

          const pT = get(p, nameType);
          return cT !== pT;
        }}>
        {(f) => {
          const { getFieldValue } = f;
          const type = getFieldValue(nameType);
          //    console.log('type', type);

          if (
            type === EType.SMALLER_THAN ||
            type === EType.LARGER_THAN ||
            type === EType.EQUALS
          ) {
            return (
              <Item
                name={nameValue}
                noStyle={noStyle}
                rules={
                  rules || [
                    {
                      required: true,
                      message: getI18n(
                        'general.advancedFilters.commonAmount.requiredMessage',
                      ),
                    },
                  ]
                }>
                <OriNumberInput
                  //autoFocus
                  suffix={suffix}
                  size='large'
                  precision={precision}
                  disabled={disabled}
                />
              </Item>
            );
          }
          if (type === EType.IN_BETWEEN) {
            return (
              <Item
                noStyle={noStyle}
                name={nameRange}
                rules={[
                  {
                    required: true,
                    validator: async (x, value) => {
                      const { from: value1, to: value2 } = value;

                      if (
                        instanceType(value1) !== AllTypes.Number ||
                        instanceType(value2) !== AllTypes.Number
                      ) {
                        return Promise.reject(
                          new Error(
                            getI18n(
                              'general.advancedFilters.commonAmount.requiredThe',
                            ),
                          ),
                        );
                      }
                      if (value2 < value1) {
                        return Promise.reject(
                          new Error(
                            getI18n(
                              'general.advancedFilters.commonAmount.requireNumber',
                            ),
                          ),
                        );
                      }
                    },
                  },
                ]}>
                <RangeNumberInput
                  disabled={disabled}
                  suffix={suffix}
                  v1Props={{ precision }}
                  v2Props={{ precision }}
                />
              </Item>
            );
          }
          return null;
        }}
      </Item>
    </React.Fragment>
  );
};
export default CommonAmount;
const RangeNumberInput = (props) => {
  const {
    onChange,
    value,
    suffix,
    whenOnChange,
    v1Props,
    v2Props,
    id,
    disabled,
  } = props;
  const { from, to } = value || {};
  const [v1, setV1] = React.useState(from || null);
  const [v2, setV2] = React.useState(to || null);
  React.useEffect(() => {
    if (from !== v1) {
      setV1(from);
    }
    if (to !== v2) {
      setV2(to);
    }
  }, [value]);
  const onV1Change = (e) => {
    setV1(e);
    if (whenOnChange)
      whenOnChange({
        from: e,
        to: v2,
      });
    if (onChange) {
      onChange({
        from: e,
        to: v2,
      });
    }
  };
  const onV2Change = (e) => {
    setV2(e);
    if (whenOnChange)
      whenOnChange({
        from: v1,
        to: e,
      });
    if (onChange) {
      onChange({
        from: v1,
        to: e,
      });
    }
  };
  return (
    <div className={numberCss.container} id={id}>
      <OriNumberInput
        bordered={false}
        value={v1}
        onChange={onV1Change}
        {...(v1Props || {})}
        className={numberCss.input1}
        size='large'
        style={{ border: 'none' }}
        disabled={disabled}
      />
      <div className={numberCss.dashContainer}>-</div>
      <OriNumberInput
        min={v1}
        bordered={false}
        suffix={suffix}
        {...(v2Props || {})}
        className={numberCss.input2}
        onChange={onV2Change}
        value={v2}
        size='large'
        style={{ border: 'none' }}
        disabled={disabled}
      />
    </div>
  );
};
export { RangeNumberInput };
